import type { FaireProductEntity } from "../../entity_types/product";

export const p_867cpnt3uq: FaireProductEntity = {
  token: "p_867cpnt3uq",
  type: "product",
  name: "Women's Plush Leopard Print Lounge Slippers",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/8d2e2e2d40e39855124100eede376158750384a91e5b56c8b28f425493c88443.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dded2e5b2de8b4ff07a3d6e8d8bfb42d31a4011b10658ddbbd287ce25414e3b8.jpeg",
    "https://cdn.faire.com/fastly/e48bb4044bd4d615843bad2ab26977c359f298ccff04b33522b47a5c41a60da0.jpeg",
    "https://cdn.faire.com/fastly/bf6b81a609298fb8704df03feb2e340f140d87b71ff9a72623b056531ca57e45.jpeg",
    "https://cdn.faire.com/fastly/decdcaa507c7fb4624346b841a0da62d8d90040fe97577c906eff2bb1f6728f6.jpeg",
    "https://cdn.faire.com/fastly/9b3767c3664fe7d35d993f1cf5e232dbb7c8bf2308957b7b7a36b559cc5bd9fb.jpeg",
    "https://cdn.faire.com/fastly/77a5f7d28e7e2396ac8d7490f2716863bfbdc1673f66d5470fcfc603e93d4d06.jpeg",
    "https://cdn.faire.com/fastly/3dd6e91dd2a78bf5f93e1e63874c043346d4ff94691ead20cf0561e4abca4ba3.jpeg",
    "https://cdn.faire.com/fastly/6e661108975883dca11af28f20dfd4cade8f80c10136f3c8083f8a05473dd5eb.jpeg",
    "https://cdn.faire.com/fastly/e48e5e145e51f96a68ddb6798ae8a06eaeb05bb342d096d5f72c226b56010410.jpeg",
    "https://cdn.faire.com/fastly/67d8c20cc23d8fc0e41ccf0e0179f40b333a8bbf69be823d1223c9a151725fb3.jpeg"
  ],
  priceDollars: 25,
  description: "Introducing Our First-Ever Marshmallow Slippers—Now in Animal Print\nFor the first time ever, Softies' iconic Marshmallow fabric is available in a slipper—bringing our cloud-soft comfort to your feet. Voted one of Oprah’s Favorite Things eight years running, Marshmallow is known for its ultra-plush feel, cozy warmth, and fuzzy finish that only gets softer with time. Designed for lounging, gifting, and everyday indulgence, our debut Marshmallow Slippers deliver the signature softness your customers know and love—now in playful animal prints for a fresh seasonal twist.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Soft indoor sole for relaxed wear\n• Ultra-soft, plush feel with a cozy, fuzzy finish\n• Perfect for gifting, self-care, or bundling with lounge sets\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞:\n• Easy Care Marshmallow Fabric: 51% polyester, 49% nylon, machine washable\n• Available in S (5–6), M (7–8), and L (9–10)",
  tags: [],
  msrpDollars: 59,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:13.583Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
